
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.75 7a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0zM12 2.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM7.702 16.702A3.25 3.25 0 0110 15.75h4A3.25 3.25 0 0117.25 19v2a.75.75 0 001.5 0v-2A4.75 4.75 0 0014 14.25h-4A4.75 4.75 0 005.25 19v2a.75.75 0 001.5 0v-2c0-.862.342-1.689.952-2.298z"}})])
          )
        }
      }
    